import { createSlice } from "@reduxjs/toolkit";

export const bankDetailsSlice = createSlice({
  name: "bankDetails",
  initialState: {
    bankDetailsList: [],
    rList: [],
    errors: {},
  },
  reducers: {
    setTypesOfBankAccount: (state, action) => {
      state.typesOfBankAccount = action.payload;
      state.errors.typesOfBankAccountError = {};
    },
    setBank: (state, action) => {
      state.bank = action.payload;
      state.errors.bankError = {};
    },
    setBankBranch: (state, action) => {
      state.bankBranch = action.payload;
      state.errors.bankBranchError = {};
    },
    setBankBranchDesc: (state, action) => {
      state.bankBranchDesc = action.payload;
    },

    setTypesOfBankAccountDesc: (state, action) => {
      state.typesOfBankAccountDesc = action.payload;
    },
    setBankDesc: (state, action) => {
      state.bankDesc = action.payload;
    },
    setBankAccountNumber: (state, action) => {
      state.bankAccountNumber = action.payload;
      state.errors.bankAccountNumberError = {};
    },
    setPrimaryAccountNo: (state, action) => {
      state.bankDetailsList.forEach((b) => {
        const isPr = !!b.isPrimaryAccount;
        b.isPrimaryAccount = b.bankAccountNumber === action.payload.bankAccountNumber &&
          b.bank == action.payload.bank &&
          b.bankBranch == action.payload.bankBranch;

        if (isPr !== b.isPrimaryAccount) {
          b.op = "U";
        }
      });
    },
    addBankDetails: (state, action) => {
      state.bankDetailsList.push({
        typesOfBankAccount: action.payload.typesOfBankAccount,
        bank: action.payload.bank,
        bankBranch: action.payload.bankBranch,
        bankAccountNumber: action.payload.bankAccountNumber,
        isPrimaryAccount: state.bankDetailsList.length
          ? action.payload.isPrimaryAccount
          : true,
        bankDesc: action.payload.bankDesc,
        bankBranchDesc: action.payload.bankBranchDesc,
        typesOfBankAccountDesc: action.payload.typesOfBankAccountDesc,
        op: "I",
      });
      state.errors = {};
      state = {};
      console.log("state", state);
    },
    removeBankDetails: (state, action) => {
      state.bankDetailsList = state.bankDetailsList.filter((bank) => {
        if (bank.bankAccountNumber == action.payload.bankAccountNumber &&
          bank.bank == action.payload.bank &&
          bank.bankBranch == action.payload.bankBranch) {

          if (bank.id) state.rList.push(bank.id);
          return false;
        }
        return true;
      });
    },
    setBankDetailsData: (state, action) => {
      state.bankDetailsList = action.payload;
    },
    resetBankDetailsData: (state, action) => {
      state.bankDetailsList = [
        ...state.bankDetailsList.filter(
          (b) => b.id && !action.payload.find((d2) => d2.id == b.id)
        ),
        ...action.payload,
      ].map((d) => ({ ...d, op: "N" }));
      state.rList = [];
    },
    clearBankData: (state, action) => {
      state.bankDetailsList.forEach((b) => (b.op = "N"));
    },
    setBankDetailsError: (state, action) => {
      state.errors.bankDetailsError = {};
      state.errors.bankDetailsError.message = action.payload.message;
      state.errors.bankDetailsError.section = action.payload.section;
    },
    setTypesOfBankAccountError: (state, action) => {
      state.errors.typesOfBankAccountError = {};
      state.errors.typesOfBankAccountError.message = action.payload.message;
      state.errors.typesOfBankAccountError.section = action.payload.section;
    },
    setBankError: (state, action) => {
      state.errors.bankError = {};
      state.errors.bankError.message = action.payload.message;
      state.errors.bankError.section = action.payload.section;
    },
    setBankAccountNumberError: (state, action) => {
      if (!state.errors.bankAccountNumberError) {
        state.errors.bankAccountNumberError = {};
      }
      state.errors.bankAccountNumberError.message = action.payload.message;
      state.errors.bankAccountNumberError.section = action.payload.section;
    },
    setBankBranchError: (state, action) => {
      state.errors.bankBranchError = {};
      state.errors.bankBranchError.message = action.payload.message;
      state.errors.bankBranchError.section = action.payload.section;
    },
    clearBankDetailsError: (state) => {
      state.errors = {};
    },
    clearBankObj: (state) => {
      state.typesOfBankAccount = null;
      state.bank = null;
      state.bankBranch = null;
      state.bankAccountNumber = '';
    },
  },
});

export const {
  clearBankData,
  setBankDetailsData,
  setTypesOfBankAccount,
  resetBankDetailsData,
  setBank,
  setBankAccountNumber,
  addBankDetails,
  removeBankDetails,
  setTypesOfBankAccountDesc,
  setBankDesc,
  setPrimaryAccountNo,
  setBankDetailsError,
  setTypesOfBankAccountError,
  setBankError,
  setBankAccountNumberError,
  setBankBranchError,
  clearBankDetailsError,
  setBankBranch,
  setBankBranchDesc,
  clearBankObj,
} = bankDetailsSlice.actions;

export default bankDetailsSlice.reducer;
